import {CircularProgress, IconButton} from "@mui/material";
import {Done, ErrorOutline, GetApp} from "@mui/icons-material";
import {analyticsExportEvent} from "../../../../services/analytics/AnalyticEvents";
import {downloadAsFile} from "../../../../components/download-data-button/DownloadAsFile";
import React, {useState} from "react";
import {useStores} from "../../../../stores";
import {reviewSnackbarController} from "../snackbar/ReviewSnackbarController.tsx";
import type {Msg} from "../snackbar/SnackbarController.ts";
import {environment} from "../../../../env.ts";
import {mithra_http} from "../../../../services/Http.tsx";

const downloadingMsg: Msg = {
    msg: 'Download in progress ...',
    severity: 'info'
};
const downloadSuccessMsg: Msg = {
    msg: 'Download completed',
    severity: 'success'
};
const downloadErrorMsg: Msg = {
    msg: 'File could not be downloaded',
    severity: 'error'
};

type Props = {
    part_id: number
    p_id: string
    filename: string
    loading?: boolean
}
export const DownloadButton: React.FC<Props> = ({part_id, p_id, filename, loading}) => {
    const {authStore, materializedApi} = useStores();
    const [state, setState] = useState<'initial' | 'downloading' | 'downloaded' | 'error'>('initial');

    const handleDownload = () => {
        setState('downloading')
        reviewSnackbarController.setContent(downloadingMsg)
        analyticsExportEvent({
            export_type: 'download_part_file',
            object_key: String(p_id),
            user: authStore.email
        })
        const $download = (environment.isDemo
                ? mithra_http.mockApi.get('/sales_demo/categorization/8c5db094_redacted.pdf', {responseType: 'blob'})
                : materializedApi.downloadPartFile(part_id)
        )
        $download
            .then(resp => {
                downloadAsFile(resp, filename);
                setState('downloaded')
                reviewSnackbarController.setContent(downloadSuccessMsg)
            })
            .catch(error => {
                console.error("Error downloading file", error)
                setState('error')
                reviewSnackbarController.setContent(downloadErrorMsg)
            })
            .finally(() => {
                reviewSnackbarController.setTimeout(5000);
            })
    };

    return <>
        <IconButton
            color="primary"
            className="btn-with-circular-progress button-spacing"
            disabled={state === 'downloading' || loading}
            onClick={handleDownload}
            title="Download file">
            {
                state === 'downloading' ? <CircularProgress size={14}/>
                    : state === 'downloaded' ? <Done/>
                        : state === 'error' ? <ErrorOutline/>
                            : <GetApp/>
            }
        </IconButton>
    </>
}
